import React from "react";
import { Adsense } from "@ctrl/react-adsense";
import { useLocation } from "../../context/LocationContext"; // Assuming LocationContext is in the same file or imported

// Function to detect device type based on user agent
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/tablet/i.test(ua)) return "tablet";
  if (/mobile/i.test(ua)) return "mobile";
  return "desktop";
};

function AdCard({ ad }) {
  // Call hook at the top level, unconditionally
  const { location } = useLocation();

  if (!ad) return null;

  const isAdsense = ad.client && ad.slot;

  // Function to track click and send to backend
  const trackClick = async (adData) => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/track-ad-click`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          zipcode: location?.zipcode || null,
          country: location?.country || null,
          deviceType: getDeviceType(),
          adId: ad.id || ad.slot || "unknown", // Use ad ID or slot as identifier
          timestamp: new Date().toISOString(),
          ...adData, // Any additional ad data
        }),
      });
    } catch (error) {
      console.error("Failed to track ad click:", error);
    }
  };

  /* ==========================
     ✅ ADSENSE (LIBRARY HANDLES PUSH)
     ========================== */
  if (isAdsense) {
    return (
      <div
        className="card"
        style={{
          padding: "12px",
          minHeight: "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        // Note: Adsense clicks are handled by Google and cannot be easily intercepted.
        // For Adsense, tracking might require Google Analytics or Adsense reporting.
        // This onClick is on the container, but won't capture actual ad clicks inside the iframe.
        onClick={() => trackClick({ type: "adsense" })}
      >
        <Adsense
          client="ca-pub-6409212221098617"
          slot="3259974102"
          style={{
            display: "inline-block",
            width: "300px",
            height: "300px",
          }}
          format=""
        />

        <div
          style={{
            fontSize: "10px",
            color: "#999",
            marginTop: "8px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Advertisement
        </div>
      </div>
    );
  }

  /* ==========================
     ✅ IMAGE AD (FALLBACK) WITH TRACKING
     ========================== */
  const { image, link } = ad;

  return (
    <div
      className="card"
      onClick={async () => {
        await trackClick({ type: "image", link });
        if (link) window.open(link, "_blank", "noopener,noreferrer");
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px",
        minHeight: "250px",
        cursor: link ? "pointer" : "default",
      }}
    >
      <img
        src={image}
        alt="Advertisement"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />

      <div
        style={{
          paddingTop: "15px",
          fontSize: "10px",
          color: "#999",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Advertisement
      </div>
    </div>
  );
}

export default AdCard;
